export const TEST_ID = {
  stepper: 'stepper',
};
